module.exports = __webpack_public_path__ + "static/media/IELTS-AcademicReading-TableMatch1.37ba9589.png";